@if (automaticBaseClaimPending) {
  <ion-spinner name="lines-small" role="status" aria-label="Preparing tickets"></ion-spinner>
}
@if (loaded) {
  <ion-content [fullscreen]="true">
    <ion-grid>
      <ion-row>
        <div class="ion-align-self-center main-container">
          @if (paymentPageData) {
            <div>
              <div #dynamicContent [innerHTML]="paymentPageData | safeHtml"></div>
            </div>
          }
        </div>
      </ion-row>
    </ion-grid>
  </ion-content>
}
